"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.BootstrapPagination = void 0;
const composition_api_1 = require("@vue/composition-api");
const _abstract_1 = require("../../_abstract");
const Button_1 = require("../Button");
const Link_1 = require("../Link");
const Pagination_hooks_1 = require("./Pagination.hooks");
/**
 * @emits change - When the User calls for the page change.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.BootstrapPagination = composition_api_1.defineComponent({
    name: 'BootstrapPagination',
    props: Pagination_hooks_1.bootstrapPaginationProps,
    components: {
        BootstrapButton: Button_1.BootstrapButton,
        BootstrapLink: Link_1.BootstrapLink
    },
    emits: ['change'],
    setup(props, ctx) {
        function resolveTarget(page) {
            if (!props.link) {
                return { target: '#' };
            }
            let target;
            if (typeof props.link.target === 'string') {
                target = `${props.link.target}${props.link.target.indexOf('?') > 0 ? '&' : '?'}${props.link.param}=${page}`;
            }
            else {
                target = {
                    ...props.link.target,
                    query: {
                        ...props.link.target.query,
                        [props.link.param]: String(page)
                    }
                };
            }
            return { target };
        }
        return {
            ..._abstract_1.usePagination(props, ctx),
            resolveTarget
        };
    },
    template: `
    <nav :aria-label="$t('_.pagination')">
    <ul class="pagination list-unstyled" v-if="totalVisible">
      <li v-if="showDirectionButtons" class="page-item" :class="{ 'disabled': !canGoBack }">
        <BootstrapLink v-if="link" class="btn btn-link page-link"
                       :link="resolveTarget(currentPage - 1)" :disabled="!canGoBack"
                       :aria-label="$t('_.previous-page')" :aria-disabled="canGoBack ? 'false' : 'true'"
                       @click.native.prevent="onPrevPageClick">&laquo;</BootstrapLink>
        <BootstrapButton v-else class="btn-link page-link"
                         :aria-label="$t('_.previous-page')" :aria-disabled="canGoBack ? 'false' : 'true'"
                         @click="onPrevPageClick">&laquo;</BootstrapButton>
      </li>

      <li v-for="(page, index) in items" :key="page + '-' + index"
          class="page-item" :class="{ 'active': page === currentPage }">
        <BootstrapLink v-if="link" class="btn btn-link page-link"
                       :link="resolveTarget(page)" :disabled="typeof page === 'string'"
                       :aria-disabled="typeof page === 'string'"
                       @click.native.prevent="onDirectPageClick(page)">{{ page }}</BootstrapLink>
        <BootstrapButton v-else class="btn-link page-link"
                         :class="{ 'disabled': typeof page === 'string' }"
                         @click="onDirectPageClick(page)">{{ page }}</BootstrapButton>
      </li>

      <li v-if="showDirectionButtons" class="page-item" :class="{ 'disabled': !canGoNext }">
        <BootstrapLink v-if="link" class="btn btn-link page-link"
                       :link="resolveTarget(currentPage + 1)" :disabled="!canGoNext"
                       :aria-label="$t('_.next-page')" :aria-disabled="canGoNext ? 'false' : 'true'"
                       @click.native.prevent="onNextPageClick">&raquo;</BootstrapLink>
        <BootstrapButton v-else class="btn-link page-link"
                         :aria-label="$t('_.next-page')" :aria-disabled="canGoNext ? 'false' : 'true'"
                         @click="onNextPageClick">&raquo;</BootstrapButton>
      </li>
    </ul>
    </nav>`
});
//# sourceMappingURL=Pagination.js.map